import { DataGrid, GridValidRowModel } from "@mui/x-data-grid";
import { CustomGridProps } from "types";

export default function CustomGrid<T extends GridValidRowModel>({
  structure,
  rows,
  selectionModel,
  onRowSelection,
  checkboxSelection = true,
  initialState,
  getRowId,
  isRowSelectable,
  hideFooter,
}: CustomGridProps<T>) {
  const { fields } = structure;

  return (
    <DataGrid
      sx={{
        "& .MuiDataGrid-cell": {
          borderRight: "1px solid #f5f5f5",
          borderBottom: "1px solid #f5f5f5",
          padding: "0px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      }}
      density="compact"
      autoHeight
      disableColumnSelector
      disableColumnMenu
      disableColumnFilter
      hideFooterSelectedRowCount
      hideFooter={hideFooter}
      localeText={{
        noRowsLabel: "No hay registros",
        footerTotalRows: "Total",
        MuiTablePagination: { labelRowsPerPage: "Filas por página" },
      }}
      columns={fields}
      isCellEditable={() => false}
      rows={rows as GridValidRowModel[]}
      getRowId={getRowId ?? ((row) => (row as any).id)}
      disableRowSelectionOnClick
      checkboxSelection={checkboxSelection}
      isRowSelectable={isRowSelectable}
      rowSelectionModel={selectionModel}
      onRowSelectionModelChange={(newSelection) => onRowSelection(newSelection)}
      initialState={initialState}
    />
  );
}
